// Función global para verificar y manejar el botón load more
window.checkLoadMoreButton = function() {
    const product_on_page = $('.product_on_page');
    const load_more_btn = $('.load-more-btn');
    
    if (product_on_page.length && load_more_btn.length) {
        const next_url = product_on_page.data('next-page');
        console.log('Load more check - Next URL:', next_url);
        
        if (!next_url || next_url === '' || next_url === 'undefined' || next_url.toString().trim() === '') {
            console.log('No valid next URL, hiding load more button');
            load_more_btn.hide();
        } else {
            console.log('Valid next URL found, showing load more button');
            load_more_btn.show();
        }
    }
};

document.addEventListener('DOMContentLoaded', function () {
    // Verificación inicial: ocultar botón si no hay next-page válida
    function checkInitialLoadMoreButton() {
        const product_on_page = $('.product_on_page');
        const load_more_btn = $('.load-more-btn');
        
        if (product_on_page.length && load_more_btn.length) {
            const next_url = product_on_page.data('next-page');
            console.log('Initial check - Next URL:', next_url);
            
            if (!next_url || next_url === '' || next_url === 'undefined' || next_url.toString().trim() === '') {
                console.log('No valid next URL on initial load, hiding button');
                load_more_btn.hide();
            }
        }
    }
    
    // Ejecutar verificación inicial
    checkInitialLoadMoreButton();
    
    // Usar event delegation en lugar de referencias estáticas
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('load-more-btn')) {
            event.preventDefault();
            loadMoreProducts();
        }
    });

    function loadMoreProducts() {
        // Buscar elementos dinámicamente cada vez
        let load_more_btn = $('.load-more-btn');
        let product_on_page = $('.product_on_page');
        
        if (!load_more_btn.length || !product_on_page.length) {
            console.warn('Load more button or product container not found');
            return;
        }

        console.log('clicked load more');
        let next_url = product_on_page.data('next-page');
        console.log('Next URL:', next_url);
        console.log('Next URL type:', typeof next_url);
        console.log('Next URL length:', next_url ? next_url.length : 'null/undefined');
        
        // Verificar si la URL es válida (no vacía, no undefined, no null)
        if (!next_url || next_url === '' || next_url === 'undefined' || next_url.toString().trim() === '') {
            console.warn('No valid next URL found, hiding load more button');
            load_more_btn.remove();
            return;
        }

        $.ajax({
            url: next_url,
            type: 'GET',
            dataType: 'html',
            beforeSend: () => {
                load_more_btn.hide();
            },
        }).done((next_page) => {
            // Volver a buscar elementos después del AJAX por si fueron regenerados
            product_on_page = $('.product_on_page');
            load_more_btn = $('.load-more-btn');
            
            const new_products = $(next_page).find('.product_on_page');
            const new_url = new_products.data('next-page');
            
            // Verificar si existe un botón de "load more" en la nueva página
            const new_load_more_btn = $(next_page).find('.load-more-btn');
            
            console.log('New URL:', new_url);
            console.log('New load more button exists:', new_load_more_btn.length > 0);
            
            // Solo mostrar el botón si:
            // 1. Hay una nueva URL para la siguiente página
            // 2. Y existe un botón "load more" en la respuesta (indica que hay más páginas)
            if (new_url && new_url !== '' && new_load_more_btn.length > 0) {
                load_more_btn.show();
            } else {
                // No hay más páginas, ocultar el botón permanentemente
                load_more_btn.remove();
                console.log('No more pages available, load more button removed');
            }

            product_on_page.data('next-page', new_url);
            product_on_page.append(new_products.html());
        }).fail((xhr, status, error) => {
            console.error('Error loading more products:', error);
            load_more_btn.show(); // Mostrar el botón nuevamente en caso de error
        });
    }
});